import 'react-app-polyfill/ie11'
import 'react-app-polyfill/ie9'
import jQuery from 'jquery'
import Popper from 'popper.js'
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

//Disabling service worker until this is installed to a production environment
// import registerServiceWorker from './registerServiceWorker'

//Visual libaries
import 'jquery-ui-bundle/jquery-ui.min.js'
import 'bootstrap'
import 'jquery-ui-bundle/jquery-ui.min.css'

//Custom CSS
import './index.css'

//Polyfills
import 'core-js/fn/array/find'
import 'core-js/fn/symbol'
import 'core-js/fn/promise'

//This mess has to be done to support jQuery and Popper from npm. See references below:
//https://stackoverflow.com/questions/28393674/jquery-not-define-in-bootstrap-module
//http://blog.npmjs.org/post/112064849860/using-jquery-plugins-with-npm
window.$ = window.jQuery = global.jquery = jQuery;
window.Popper = Popper;

window.$(document).ready(function() {
    let root = document.getElementById('root');

    var toggleSelector = '[data-toggle="{0}"]';

    jQuery(toggleSelector.replace('{0}', 'tooltip')).tooltip(
        {
            placement: 'bottom',
            animate: 'hover',
            animation: false,
        }
    );

    var progressBar = jQuery('.static-progress-bar').first();
    loadProgressBar(progressBar);

    if (root) {
        import('./AppBrowser')
        .then(({AppBrowser}) => {
            ReactDOM.render(<AppBrowser/>, root)
        })
        .catch(err => {
            // Handle failure
        });
    }
});

function loadProgressBar(element) {
  var control = jQuery(element);

  var completesAt = 100;
  var totalTime = 1500;
  var counter = 0;

  var waitPerPercent = totalTime/completesAt;
  
  function incrementProgressBar() {  
    setTimeout(function() {
      if (counter <= completesAt) {
        jQuery(control).width(counter + '%');
        counter++;
        incrementProgressBar();
      }
    }, waitPerPercent);
  }

  //Call first time
  incrementProgressBar();
}


//Disabling service worker until this is installed to a production environment
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js